import React from "react";
import { getScoreTone } from "../utils/dashboardBottomUtils";
import "./AccuracyRing.css";

const RING_RADIUS = 28;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

const AccuracyRing = ({ percent }) => {
  const value = Math.min(100, Math.max(0, Number(percent) || 0));
  const tone = getScoreTone(value);
  const dashOffset = RING_CIRCUMFERENCE - (value / 100) * RING_CIRCUMFERENCE;

  return (
    <div className={`accuracy-ring accuracy-ring--${tone}`} aria-hidden="true">
      <svg className="accuracy-ring__svg" viewBox="0 0 64 64">
        <circle className="accuracy-ring__track" cx="32" cy="32" r={RING_RADIUS} />
        <circle
          className="accuracy-ring__fill"
          cx="32"
          cy="32"
          r={RING_RADIUS}
          strokeDasharray={RING_CIRCUMFERENCE}
          strokeDashoffset={dashOffset}
        />
      </svg>
      <span className="accuracy-ring__label">{Math.round(value)}%</span>
    </div>
  );
};

export default AccuracyRing;
